import api from '../api'

export function getLiveKitToken(roomName) {
  return async function getLiveKitTokenAction() {
    return await api.getLiveKitToken(roomName)
  }
}

export function createVideoCallRoom(roomName, participantApikeys) {
  return async function createVideoCallRoomAction() {
    return await api.createVideoCallRoom(roomName, participantApikeys)
  }
}

export function initiateCall({ chatChannelUid, callType, callerName, chatName, organizationApikey, memberUserDids }) {
  return async function initiateCallAction() {
    return await api.initiateCall({
      chatChannelUid,
      callType,
      callerName,
      chatName,
      organizationApikey,
      memberUserDids
    })
  }
}

export function respondToCall({ chatChannelUid, roomName, response, responderName }) {
  return async function respondToCallAction() {
    return await api.respondToCall({ chatChannelUid, roomName, response, responderName })
  }
}

export function joinCall({ roomName, participantName }) {
  return async function joinCallAction() {
    return await api.joinCall({ roomName, participantName })
  }
}
